import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { watch } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageWithFields, type WebSocketMessageEmpty } from '@/plugins/ws';

import {RootState} from "@/store";

type PriceExchangeWithIndex = {
  indexExchange: number;
};

// Типы для WebSocket сообщений компонента priceExchanges
type PriceExchangesListMessage = WebSocketMessageWithFields<'store-info' | 'store-sync' | 'stream-info', {
  priceExchanges: unknown[];
}>;
type PriceExchangeCreateMessage = WebSocketMessageWithFields<'store-price-exchange-create', PriceExchangeWithIndex & {
  code: string;
}>;
type PriceExchangeInfoMessage = WebSocketMessageWithFields<'store-exchange-info', {
  priceExchange: {
    indexExchange: number;
    code: string;
  };
}>;
type PriceExchangeInfoNotFoundMessage = WebSocketMessageEmpty<'store-exchange-info-not-found'>;

// Объединенный тип для всех сообщений
type PriceExchangesWebSocketMessage = 
  | PriceExchangesListMessage 
  | PriceExchangeCreateMessage 
  | PriceExchangeInfoMessage 
  | PriceExchangeInfoNotFoundMessage;

// WebSocket message handler

export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'dataPriceExchanges',
},
  __name: 'priceExchanges',
  setup(__props) {

const store = useStore<RootState>();



// Базовый тип для сообщений с индексом биржи
const handleWebSocketMessage = (data: PriceExchangesWebSocketMessage): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'store-info':
    case 'store-sync':
    case 'stream-info':
      store.dispatch('priceExchanges/wsSetPriceExchanges', {
        priceExchanges: data.priceExchanges,
      });
      break;

    case 'store-price-exchange-create':
      store.dispatch('priceExchanges/wsPriceExchangeCreate', {
        indexExchange: data.indexExchange,
        code: data.code,
      });
      break;

    case 'store-exchange-info':
      store.dispatch('priceExchange/wsSetPriceExchange', {
        indexExchange: data.priceExchange.indexExchange,
        code: data.priceExchange.code,
      });
      break;

    case 'store-exchange-info-not-found':
      store.dispatch('priceExchange/wsSetEmptyPriceExchange');
      break;
  }
};

watch(latestMessage, handleWebSocketMessage);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})